import React, { useState, useEffect } from 'react';
import OrderFulfillmentChart from '../chart/OrderFulfillmentChart';
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import OperatorPerformamceModal from '../modal/OperatorPerformamceModal'
import IndividualMachineStatusModal from '../modal/IndividualMachineStatusModal'
import MaintenancescheduleModal from '../modal/MaintenancescheduleModal';
import config from "../../config/config";
import PlanActualReport from '../seniorManagement/PlanActualReport';
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";
import ProductionPlan from './ProductionPlan';
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      fontSize: '14px',
      backgroundColor: '#f8f9fa',
    },
  },
};
export default function Performance() {
  const [operatorPerformance, setOperatorPerformance] = useState(false)
  const [maintenanceschedule, setMaintenanceschedule] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [personalproduct, setPersonalproduct] = useState([])
  const [machineproduct, setMachineproduct] = useState([])
  const [loading, setLoading] = useState(false);
  const [machineUtilization, setMachineUtilization] = useState([]);
  const [operatorId, setOperatorId] = useState(null)
  const [machineId, setMachineId] = useState(null)
  const [criticalmetrics, setCriticalmetrics] = useState([])
  const fetchPersonalproduct = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/personalproductivity`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        setPersonalproduct(result?.operator);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching fetchPersonalproduct:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchMachineproduction = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/machineproductiontrend`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        setMachineproduct(result?.utlization);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching fetchMachineproduction:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchMachineUtilization = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/MachineUtilizationTrend`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data?.weeks;
      setMachineUtilization(result);
    } catch (err) {
      console.error("Error fetching MachineUtilizationTrend:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const labels = machineUtilization.map(item => `Week ${item.week_number}`);
  const dataPoints = machineUtilization.map(item => Number(item?.total_utilization));
  const fetchCriticalmetrics = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/criticalmetrics`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.data && response?.data?.success === true) {
        const result = response?.data?.data;
        setCriticalmetrics(result?.metrics);
      } else {
        console.warn("Critical metrics fetch failed:", response.data?.message || "Unknown error");
      }
    } catch (err) {
      console.error("Error fetching critical metrics:", err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPersonalproduct();
    fetchMachineproduction();
    fetchMachineUtilization();
    fetchCriticalmetrics();
  }, []);
  const ProgressBarDark = ({ value }) => {
    const displayValue =
      typeof value === "number" ? value.toFixed(2) : "0.00";
    return (
      <div className="d-flex align-items-center w-75">
        <div className="progress flex-grow-1" style={{ height: "14px" }}>
          <div
            className="progress-bar bg-dark text-white d-flex justify-content-center align-items-center"
            role="progressbar"
            style={{ width: `${displayValue}%` }}
            aria-valuenow={displayValue}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {displayValue}%
          </div>
        </div>
      </div>
    );
  };
  const columns = [
    {
      name: 'EMPLOYEE',
      selector: row => row.name,
      cell: row => (
        <span
          style={{ cursor: 'pointer' }}
        // onClick={() => setOperatorPerformance(true)}
        >
          {row.user.name}
        </span>
      ),
    },
    { name: 'ROLE', selector: row => row?.user?.role },
    { name: 'DEPARTMENT', selector: row => row?.machine?.department },
    {
      name: "EFFICIENCY",
      selector: row =>
        row?.target > 0
          ? (row?.total_produced / Number(row?.target)) * 100
          : 0,
      cell: row => {
        const efficiency =
          row?.target > 0
            ? (row?.total_produced / Number(row?.target)) * 100
            : 0;
        return <ProgressBarDark value={efficiency} />;
      }
    },
    {
      name: "QUALITY",
      selector: row =>
        row?.total_produced > 0
          ? ((row?.total_produced - row?.total_rejected) / row?.total_produced) * 100
          : 0,
      cell: row => {
        const quality =
          row?.total_produced > 0
            ? ((row?.total_produced - row?.total_rejected) / row?.total_produced) * 100
            : 0;
        return <ProgressBarDark value={quality} />;
      }
    },
    {
      name: "ATTENDANCE",
      selector: row => row.attendance,
      cell: row => <ProgressBarDark value={100} />,
    },
    {
      name: 'ACTIONS',
      cell: row => (
        <Button
          variant={row.action === 'Take Action' ? 'dark' : 'outline-secondary'}
          size="sm" onClick={() => { setOperatorId(row?.user?.id); setOperatorPerformance(true) }}
        >
          View Details
        </Button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const getBadges = (text, type) => {
    const colorMap = {
      pending: "warning-subtle",
      Running: "success-subtle",
      rejected: "danger-subtle",
    };
    const badgeColor = colorMap[type] || "danger-subtle";
    return (
      <span className={`badge bg-${badgeColor} text-dark p-2`}>
        {text}
      </span>
    );
  };
  const Machinecolumns = [
    {
      name: 'MACHINE',
      selector: row => row?.machine?.name,
      cell: row => (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setShowModal(true);
            setMachineId(row?.machine?.id);
          }}
        >
          {row?.machine?.name}-{row?.machine?.machine_code}
        </span>
      )
    },
    { name: "OUTPUT", selector: (row) => row?.units_produced },
    { name: "UPTIME", selector: (row) => row?.uptime_days ?? 1 },
    {
      name: "EFFICIENCY",
      selector: (row) =>
        row?.productivity_percentage
          ? row.productivity_percentage.toFixed(2)
          : "0.00",
    },

    { name: "MAINTENANCE", selector: (row) => row.days_to_next_maintenance ?? 'NA' },
    {
      name: "STATUS",
      cell: (row) => getBadges(row?.machine_status, row?.machine_status)
    },
  ];


  return (
    <div className="container-fluid">
      <div className="row g-3 mt-2 font_family">
        <div className="col-12 col-md-6 d-flex">
          <div className="p-3 border rounded bg-light w-100 h-100">
            <strong className='fs-4'>Machine Utillization Trend</strong>
            {
              loading ? (
                <Loader />
              ) : (
                <OrderFulfillmentChart labels={labels} dataPoints={dataPoints} />
              )
            }
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex">
          <div className="p-3 border rounded bg-light w-100 h-100">
            <strong className='fs-4'>Critical Metrics</strong>
            {
              loading ? (
                <Loader />
              ) : (
                <div className="card-body mt-4">
                  {criticalmetrics.map((item, idx) => {
                    return (
                      <div key={idx} className="mb-3">
                        <div className="d-flex justify-content-between mb-1">
                          <span>{item.name} {" "}</span>
                          <span>
                            {item.actual}/{item.target} ({item?.percentage}%)
                          </span>
                        </div>
                        <div className="progress" style={{ height: "8px" }}>
                          <div
                            className={`progress-bar ${item?.percentage >= 100 ? "bg-success" : "bg-dark"
                              }`}
                            style={{ width: `${item?.percentage}%` }}
                          ></div>

                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            }
          </div>
        </div>
      </div>
      <div className="row mt-3 m-1">
        <div className="card shadow-sm m-1 p-2">
          <strong className="fs-4">Personnel Performance</strong>
          {
            loading ? (
              <Loader />
            ) : (
              <DataTable
                columns={columns}
                data={personalproduct}
                customStyles={customStyles}
                striped
                highlightOnHover
                responsive
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
              />
            )
          }
        </div>
      </div>
      <div className="row mt-4 m-1">
        <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <strong className='fs-4'>Machine Performance</strong>
            <button className="btn btn-dark" onClick={() => setMaintenanceschedule(true)}>Schedule Maintenance</button>
          </div>
          <DataTable
            columns={Machinecolumns}
            data={machineproduct}
            customStyles={customStyles}
            responsive
            striped
            highlightOnHover
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100]}
          />
        </div>
      </div>
      {/* OperatorPerformamceModal */}
      <OperatorPerformamceModal
        show={operatorPerformance}
        operatorIds={operatorId}
        handleClose={() => setOperatorPerformance(false)}
      />
      <IndividualMachineStatusModal
        machineId={machineId}
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
      {/* MaintenancescheduleModal */}
      <MaintenancescheduleModal
        show={maintenanceschedule}
        handleClose={() => setMaintenanceschedule(false)}
      />
      <PlanActualReport />
      <ProductionPlan />
    </div>
  );
}


